import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "image_active",
  "use": "image_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"image_active\"><path fill-rule=\"evenodd\" d=\"M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-12h2v2h-2V6Zm-7 8 3.418-4.665L11.12 13l2.24-1.52L16 14s-1.748 3-6 3-6-3-6-3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol